
import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Icon from '@mdi/react';
import { mdiExitToApp, mdiGiftOffOutline, mdiPackageVariant, mdiPackageVariantClosed, mdiWarehouse } from '@mdi/js';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { Dialog, DialogTitle, Divider, DialogActions, Button, Paper, Grid, Typography } from '@material-ui/core';





const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tileBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '100%',
      padding: '8px'
    },
    paperCards: {
      textAlign: 'center',
      padding: '16px',
      cursor: 'pointer',
    }

  })
);
const MobileHome = () => {

  const [openConfirmLogoutBox, setOpenConfirmLogoutBox] = React.useState(false);
  const history = useHistory();
  const classes = useStyles();

  const handleLogout = (e: React.MouseEvent<unknown>) => {
    e.preventDefault();
    setOpenConfirmLogoutBox(true);
  };
  const handleOpenConfirmLogoutBox = () => {
    setOpenConfirmLogoutBox(false);
    window.location.href = '/login';
  };
  return (
    <div>
      <Grid container>
        <Paper
          className={classes.tileBar}
        >
          <div>
            <Typography variant="h6" component="h2">
              {` اپراتور انبار داخلی `}
            </Typography>
          </div>

        </Paper>
      </Grid>
      <Grid container xs={12} spacing={1} >
        <Grid xs={6} item >
          <Link to='/warehouse-operator-orders-mob' style={{ textDecoration: 'none', width: '100%' }}>
            <Paper elevation={2} className={classes.paperCards}>
              <Icon path={mdiPackageVariant} size={2} />
              <Typography >
                سفارش‌های تخصیص داده شده
              </Typography>
            </Paper>
          </Link>
        </Grid>
        <Grid xs={6} item   >
          <Link to='/canceled-orders' style={{ textDecoration: 'none', width: '100%' }}>
            <Paper elevation={2} className={classes.paperCards}>
              <Icon path={mdiGiftOffOutline} size={2} />
              <Typography style={{ padding: '1px' }}>
                سفارش های کنسل شده
              </Typography>
            </Paper>
          </Link>
        </Grid>
        <Grid xs={6} item >
          <Link to='/parcels-warehouse-operator-mob' style={{ textDecoration: 'none', width: '100%' }}>
            <Paper elevation={2} className={classes.paperCards}>
              <Icon path={mdiPackageVariantClosed} size={2} />
              <Typography>
                محموله
              </Typography>
            </Paper>
          </Link>
        </Grid>
        <Grid xs={6} item >
          <Link to='relocate/by-item' style={{ textDecoration: 'none', width: '100%' }}>
            <Paper elevation={2} className={classes.paperCards}>
              <Icon path={mdiWarehouse} size={2} />
              <Typography>
                جابه‌جایی
              </Typography>
            </Paper>
          </Link>
        </Grid>
        <Button onClick={handleLogout} style={{ position: 'fixed', bottom: '5px', right: '5px' }}>

          <Icon path={mdiExitToApp} size={1.5} style={{ marginLeft: '4px' }} />
          <Typography>

            {' خروج  '}
          </Typography>
        </Button>
      </Grid>

      <Dialog
        fullWidth
        open={openConfirmLogoutBox}
        onClose={() => setOpenConfirmLogoutBox(false)}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <Typography>

            {' از خروج از پنل ادمین اطمینان دارید؟'}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={handleOpenConfirmLogoutBox}
                variant="contained"
                color="primary"
                data-cy="logout-click"
              >
                {'خروج از پنل'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                fullWidth
                autoFocus
                variant="outlined"
                onClick={() => setOpenConfirmLogoutBox(false)}
                color="primary"
              >
                {'انصراف'}
              </Button>
            </Grid>
          </Grid>


        </DialogActions>
      </Dialog>
    </div>
  )
}

export default MobileHome